import { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function UsdtqrDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [imglink, setimglink] = useState("");
  const [upiid, setupiid] = useState("");
  const [type, setType] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [isloading, setisloading] = useState(false);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/adminBankDetailsByBankidAdmin",
        {
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          imglink: <img src={`${item?.imglink}`} width={300} />,
          btcaddress: `${item?.btcaddress} `,
          edate: `${item?.edate}`,
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      setisloading(true);
      //   if (!type) {
      //     toast.error("Select Type !!");
      //     setisloading(false);
      //     return;
      //   }
      if (!upiid) {
        toast.error("Enter UPI Id !!");
        setisloading(false);
        return;
      }
      let responceRight = await API?.post(
        `updateDepositDetails`,
        {
          loginid: userId,
          btcAddress: upiid,
          imglink: imglink,
          Type: 1,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("submit", responceRight?.data?.data);
      if (responceRight?.data?.data == "Success") {
        toast.success("Updated Successfully !!");
        referral_API();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
        setisloading(false);
      }
    } catch (e) {
      setisloading(false);
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "UPI Id", accessor: "btcaddress" },
      { Header: "QR Code", accessor: "imglink" },
      { Header: "Date ", accessor: "edate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title"> Update QR Details</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <>
                        {" "}
                        <div className="row mb-5">
                          <form>
                            {/* <div className="col-sm-2">
                              <select
                                name="adress"
                                id="adres"
                                className="form-control in-ip-1"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Type
                                </option>
                                <option value="1">BEP 20</option>
                              </select>
                            </div> */}
                            <div className="col-sm-4">
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                onChange={(e) => setupiid(e.target.value)}
                                name="upiid"
                                placeholder="Enter UPI Id"
                                type="text"
                                value={upiid}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-4">
                              <input
                                className="form-control in-ip-1"
                                id="imglink"
                                onChange={(e) => setimglink(e.target.value)}
                                name="imglink"
                                placeholder="Enter Image Link"
                                type="text"
                                value={imglink}
                              />
                              <p>
                                <a
                                  href="https://tools.atatus.net/tools/image-to-url"
                                  target="_blank"
                                >
                                  Go to Convert Image to Link
                                </a>
                              </p>
                            </div>

                            <div className="col-sm-2">
                              <input
                                type="button"
                                id="btnsearch"
                                onClick={() => OnhandleSubmit_API()}
                                className="btn btn-lg btn-primary"
                                disabled={isloading}
                                value={isloading ? "Processing.." : "Update"}
                              />
                            </div>
                          </form>
                        </div>
                      </>
                      <div className="row panel panel-primary">
                        <div className="panel-heading">
                          <h4 className="panel-title"> QR Details</h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
